export const STRESS_TEST_FIELD_PROJECTED_REVENUE = "projected_revenue";
export const STRESS_TEST_FIELD_INCOME_BEFORE_INSURANCE = "income_before_insurance";
export const STRESS_TEST_FIELD_NET_INCOME_AFTER_INSURANCE = "net_income_after_insurance";
export const STRESS_TEST_FIELD_NET_INSURANCE_BENEFIT = "net_insurance_benefit";
export const STRESS_TEST_FIELD_REVENUE_PER_ACRE = "revenue_simple";
export const STRESS_TEST_FIELD_NET_PROFIT_SIMPLE = "net_profit_simple";
export const STRESS_TEST_FIELD_NET_PROFIT_INSURED = "net_profit_insured";
export const STRESS_TEST_FIELD_NET_INSURANCE_BENEFIT_PER_ACRE = "net_insurance_benefit_per_acre";
export const STRESS_TEST_FIELD_INDEMNITY_TOTAL_PER_ACRE = "indemnity_total_per_acre";
export const STRESS_TEST_FIELD_INCOME_PER_ACRE_BEFORE_INSURANCE = "income_per_acre_before_insurance";
export const STRESS_TEST_FIELD_INCOME_PER_ACRE_WITH_INSURANCE = "income_per_acre_with_insurance";

const STRESS_TEST_FIELD_LABELS = {
  [STRESS_TEST_FIELD_PROJECTED_REVENUE]: "Projected Revenue",
  [STRESS_TEST_FIELD_INCOME_BEFORE_INSURANCE]: "Income Before Insurance",
  [STRESS_TEST_FIELD_NET_INCOME_AFTER_INSURANCE]: "Net Income After Insurance",
  [STRESS_TEST_FIELD_NET_INSURANCE_BENEFIT]: "Net Insurance Benefit",
  [STRESS_TEST_FIELD_REVENUE_PER_ACRE]: "Revenue Per Acre",
  [STRESS_TEST_FIELD_NET_PROFIT_SIMPLE]: "Net Profit Before Insurance",
  [STRESS_TEST_FIELD_NET_PROFIT_INSURED]: "Insured Net Profit",
  [STRESS_TEST_FIELD_NET_INSURANCE_BENEFIT_PER_ACRE]: "Net Insurance Benefit per Acre",
  [STRESS_TEST_FIELD_INDEMNITY_TOTAL_PER_ACRE]: "Insurance Benefit",
  [STRESS_TEST_FIELD_INCOME_PER_ACRE_BEFORE_INSURANCE]: "Income per Acre Before Insurance",
  [STRESS_TEST_FIELD_INCOME_PER_ACRE_WITH_INSURANCE]: "Income per Acre With Insurance",
};

export const calculateStressTestDisplayFieldLabel = (stressTestDisplayField) => {
  return STRESS_TEST_FIELD_LABELS[stressTestDisplayField] || stressTestDisplayField;
};
